<template>
    <footer class="footer" ref="refFooter">
        <div class="footer__left">
            <div v-if="showCookieBanner" class="footer__cookie-banner">
                <p class="footer__cookie-banner-text">
                    Продолжая использовать наш сайт, ты даешь согласие на обработку файлов cookie и пользовательских данных в целях эффективной работы сайта, а также проведения ретаргетинга и статистических исследований. Ты можешь запретить использование файлов cookie в настройках браузера.
                </p>
                <Button
                    outlined
                    class="footer__cookie-accept-button"
                    @click="updateAcceptedAtCookie"
                >Согласен</Button>
            </div>
            <div class="footer__left-copyright">
                <div>&copy; {{ year }} &laquo;Россия &mdash; страна возможностей&raquo;.&nbsp;</div>
                <div>Все права защищены</div>
            </div>
            <div class="footer__left-links">
                <a class="footer__left-link" v-for="(item, i) of secondaryLinks" :key="i" :href="item.link">
                    {{ item.title }}
                </a>
            </div>
            <a class="footer__left-link" href="https://rsv.ru/sveden/common/"
                >Сведения об образовательной организации</a
            >
        </div>
        <div class="footer__center">
            <SocialLinks class="social-links--footer" vk max ok tg youtube rutube yappy dzen tenchat size="small" />
        </div>
        <div class="footer__right">
            <a v-if="otherLinks.nationalProjects" :href="otherLinks.nationalProjects" target="_blank">
                <NotionalProjects class="other-icon other-icon--national-projects" />
            </a>
            <a v-if="appLinks.rustore" :href="appLinks.rustore" target="_blank">
                <RuStoreIcon class="app-icon app-icon--rustore" />
            </a>
            <a v-if="appLinks.apple" :href="appLinks.apple" target="_blank">
                <AppStoreIcon class="app-icon app-icon--apple" />
            </a>
        </div>
    </footer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import RuStoreIcon from '@/assets/images/mobile-apps/rustore.svg?inline';
import AppStoreIcon from '@/assets/images/mobile-apps/app-store-white.svg?inline';
import NotionalProjects from '@/assets/images/molodezh_deti.svg?inline';
import SocialLinks from '@/components/UI/SocialLinks.vue';
import Button from '@/components/UI/Button.vue';

const getters = ['docLinks', 'contacts'];
const mutations = ['setFooterHeight'];

const actions = ['getContacts'];

export default {
    components: {
        RuStoreIcon,
        AppStoreIcon,
        NotionalProjects,
        SocialLinks,
        Button,
    },
    data: () => ({
        secondaryLinks: {
            'terms-of-use': {
                title: 'Пользовательское соглашение',
                link: '111',
                blank: true,
            },
            'data-processing-policy': {
                title: 'Политика обработки персональных данных',
                link: '222',
                blank: true,
            },
        },
        appLinks: {
            apple: 'https://apps.apple.com/ru/app/%D1%80%D0%BE%D1%81%D1%81%D0%B8%D1%8F-%D1%81%D1%82%D1%80%D0%B0%D0%BD%D0%B0-%D0%B2%D0%BE%D0%B7%D0%BC%D0%BE%D0%B6%D0%BD%D0%BE%D1%81%D1%82%D0%B5%D0%B9/id6443535931',
            rustore: 'https://apps.rustore.ru/app/ru.rsv.rsv_platforma_flutter',
        },
        otherLinks: {
            nationalProjects: 'https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/new-projects/molodezh-i-deti/',
        },
        showCookieBanner: false,
    }),
    computed: {
        ...mapGetters(getters),
        year() {
            return new Date().getFullYear();
        },
    },
    methods: {
        ...mapMutations(mutations),
        ...mapActions(actions),
        takeMeasurements() {
            this.$nextTick(() => {
                const element = this.$refs.refFooter;
                if (element) {
                    const height = element.scrollHeight;
                    this.setFooterHeight(height);
                }
            });
        },
        showSupportForm() {
            this.defaultEmail = this.userProfileInfo.regEmail ? this.userProfileInfo.regEmail : '';
            this.defaultName = this.userProfileInfo.name ? this.userProfileInfo.name : '';
            this.isSupportFormShown = true;
        },
        async getLinks() {
            await this.getContacts();

            for (let key in this.secondaryLinks) {
                if (this.docLinks[key]) {
                    this.secondaryLinks[key].link = this.docLinks[key].link;
                }
            }
        },
        async checkAcceptedCookies() {
            const rsvCookiesAccepted = window.localStorage.getItem('rsv_cookies_accepted');
            const rsvCookiesAcceptedAt = window.localStorage.getItem('rsv_cookies_accepted_at');
            if(!rsvCookiesAccepted || !rsvCookiesAcceptedAt) {
                window.localStorage.setItem('rsv_cookies_accepted', 'false');
                window.localStorage.setItem('rsv_cookies_accepted_at', '');
                this.showCookieBanner = true;
            }
            else if(rsvCookiesAccepted === 'false' || (this.docLinks['accept-cookies'] && rsvCookiesAcceptedAt < this.docLinks['accept-cookies'].updated_at)) {
                this.$nextTick(() => {
                    this.showCookieBanner = true;
                });
            }
        },
        updateAcceptedAtCookie() {
            window.localStorage.setItem('rsv_cookies_accepted_at', Date.now());
            window.localStorage.setItem('rsv_cookies_accepted', 'true');
            this.showCookieBanner = false;
        },
    },

    async mounted() {
        await this.takeMeasurements();
        await this.getLinks();
        await this.checkAcceptedCookies();
    },

    updated() {
        this.takeMeasurements();
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';
@import '~@/styles/buttons_v2.scss';

.app-icon {
    height: mrem(30);
    color: RGB(from var(--color-primary) r g b / 0.6);

    @include on-desktop {
        height: rem(30);
    }

    &--rustore {
        height: urem(26);
    }
    &--apple {
        height: urem(26);
    }
}

.other-icon {
    height: mrem(30);

    @include on-desktop {
        height: rem(46);
    }

    &--national-projects {
        width: auto;
        height: mrem(31);
        color: RGB(from var(--color-primary) r g b / 0.6);

        @include on-desktop {
            height: rem(37);
            position: relative;
            top: rem(6);
        }
    }
}

.row {
    display: flex;

    &--reverse {
        flex-direction: column-reverse;

        @include on-desktop {
            flex-direction: row;
        }
    }

    &--align-center {
        align-items: center;
    }
}

.col {
    flex: 1;

    &--3 {
        flex: 3;
    }

    &-apps {
        width: 100%;

        @include on-desktop {
            width: rem(490);
        }
    }

    &-share {
        width: 100%;

        @include on-desktop {
            width: auto;
        }
    }

    &--no-grow {
        flex-grow: unset;
    }
}

.footer {
    background: var(--color-white);
    padding: mrem(20);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: urem(16);
    color: rgba(255, 255, 255, 0.6);
    font-family: GolosText, sans-serif;
    font-weight: 700;
    position: relative;
    padding-bottom: mrem(65);
    box-shadow: 0 urem(-2) urem(16) 0 #4663AB29;

    @include on-desktop {
        width: 100%;
        flex-direction: row;
        align-items: center;
        padding: rem(12) rem(156);
    }

    &__left {
        margin: mrem(8) 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @include on-desktop {
            margin: 0;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-start;
        }
    }
    &__left-links {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @include on-desktop {
            flex-direction: row;
            align-items: center;
        }
    }
    &__left-link {
        font-size: mrem(15);
        font-weight: 400;
        color: RGB(from var(--color-primary) r g b / 0.6);
        margin: 0;
        margin-bottom: mrem(2);
        line-height: mrem(24);

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(20);
            display: flex;
            align-items: center;
            margin: 0;
            margin-right: rem(16);

            &:hover {
                color: var(--color-primary);
                text-decoration: none;
            }
        }
    }
    &__left-copyright {
        font-size: mrem(14);
        line-height: mrem(20);
        font-weight: 700;
        color: RGB(from var(--color-primary) r g b / 0.6);
        margin: 0 0 mrem(8) 0;
        position: absolute;
        bottom: 0;
        left: mrem(16);

        @include on-desktop {
            position: static;
            margin-bottom: 0;
            font-size: rem(14);
            line-height: rem(18);
            display: flex;
            align-items: center;
        }
    }

    &__center {
        flex: 2;
        @include on-desktop {
            padding-left: rem(80);
            display: inline-flex;
        }
        a {
            font-family: 'Circe Rounded', sans-serif;
            font-weight: 350;
            display: block;
            color: rgba(255, 255, 255, 0.6);
            margin: 0 0 mrem(8) 0;
            font-size: mrem(16);

            @include on-desktop {
                margin: 0 rem(12);
                font-size: rem(16);
                display: inline;
            }
            &:hover {
                color: #fff;
            }
        }
    }

    &__right {
        margin: mrem(8) 0;
        display: flex;
        align-items: center;
        gap: urem(14);

        @include on-desktop {
            margin: 0;
        }
    }

    &__cookie-banner {
        position: fixed;
        display: flex;
        flex-direction: column;
        align-items: center;
        bottom: 0;
        left: 0;
        right: 0;
        padding: urem(12);
        background-color: #e9f2fe;
        z-index: 9999;
        @include on-desktop {
            justify-content: space-between;
            flex-direction: row;
            min-height: urem(80);
            padding: 0 urem(156);
        }
    }
    &__cookie-banner-text {
        font-weight: 500;
        color: $color-black-text;
        font-size: urem(16);
        line-height: urem(24);
        a {
            color: $color-main-primary;
        }

        @include on-desktop {
            margin-right: urem(12);
        }
    }
    &__cookie-accept-button {
        border-radius: urem(24);
        @include set-font-size(16, 600, 18);
        display: flex;
        gap: urem(16);
        padding: urem(10) urem(34) ;
        @include on-desktop {
            margin-right: urem(60);
        }
    }
}
</style>
